import React from 'react';
import { connect } from 'react-redux';
import { giveUserPromotion } from "../../actions/adminActions";
import { Field, reduxForm, reset } from 'redux-form'
import { required, email } from "../validations";
import { renderFieldWithShake } from "../../utils/renderFields";
import  normalizeAmount  from "../../utils/inputNormalizer";

var panelStyle = { padding: '20px' }

class Promotion extends React.Component {

    handleFormSubmit(values) {
        if (this.props.valid) {

            var amount = values.amount.replace("$","");            

            this.props.giveUserPromotion(
                this.props.user.id,
                amount
            );
            this.props.clear();
        }
    }
    render() {
        const { handleSubmit, pristine, reset, submitting, valid, working} = this.props;

        return (

            <div>
                <br />
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel settings-form deposit" style={panelStyle}>
                                <form id="withdraw-form" method="post" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Field
                                                name="amount"
                                                type="text"
                                                component={renderFieldWithShake}
                                                label="Bonus amount"
                                                placeholder=" e.g. $100"
                                                validate={[required]}
                                                normalize={normalizeAmount}
                                            />
					                    </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-center">
                                            <button type="submit" className={'button warning' + (!valid || pristine || submitting ? ' disabledBtn' : '')} name="button" disabled={!valid || pristine || submitting}>
                                                {working ? 'Working...' : 'GIVE PROMOTION'}
                                            </button>
                                        </div>
                                    </div>
                                 </form>
                            </div>
                        </div>
	                </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { working, type, message } = state.userReducer;
    return {
        working, type, message
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //functions
        giveUserPromotion: (id, amount) => dispatch(giveUserPromotion(id, amount)),
        clear: () => dispatch(reset('promotion')) 
    };

}

Promotion = reduxForm({
    form: 'promotion'
})(Promotion);

Promotion = connect(mapStateToProps, mapDispatchToProps)(Promotion);

export default Promotion;